import { useSyncExternalStore } from 'react'

const subscribe = (onStoreChange: () => void) => {
  const handleVisibilityChange = () => {
    console.debug(`👀 Page is now ${document.visibilityState}, ${Date.now()}`)
    onStoreChange()
  }

  document.addEventListener('visibilitychange', handleVisibilityChange)

  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  }
}

const getSnapshot = (): DocumentVisibilityState => document.visibilityState

export function usePageVisible(): boolean {
  const visibility = useSyncExternalStore(subscribe, getSnapshot)

  return visibility === 'visible'
}
